<section
  class="preview-image-container d-flex align-items-center justify-content-center p-5"
>
  <img alt="preview-image" [src]="imageSrc" [default]="defaultImageSrc" />
</section>
